/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rest: NonNullable<unknown> }} Team_Summary_Memory_SingleInputs */



/**
* | output |
* | --- |
* | "For one of them, Wundo already helps you prepare and keeps track of what you've discussed. {rest} to go, and you'll have everything at hand for every 1:1." |
*
* @param {Team_Summary_Memory_SingleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_memory_single = /** @type {((inputs: Team_Summary_Memory_SingleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_Memory_SingleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Bij één van hen helpt Wundo je al bij de voorbereiding en houdt het de rode draad van jullie gesprekken bij. Nog ${i?.rest} te gaan, en je hebt alles bij de hand voor elke 1:1.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pour l'un d'entre eux, Wundo vous aide déjà à préparer et garde le fil de vos échanges. Encore ${i?.rest}, et vous avez tout sous la main pour chaque one-to-one.`)
	return /** @type {LocalizedString} */ (`For one of them, Wundo already helps you prepare and keeps track of what you've discussed. ${i?.rest} to go, and you'll have everything at hand for every 1:1.`)
});